import { render, staticRenderFns } from "./OrganizationFilter.vue?vue&type=template&id=23cc6ac3&scoped=true&"
import script from "./OrganizationFilter.vue?vue&type=script&lang=ts&"
export * from "./OrganizationFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cc6ac3",
  null
  
)

export default component.exports